import { create } from "zustand"

interface AllQuestsSearchStore {
  searchQuery: string
  setSearchQuery: (searchQuery: string) => void
}

export const useAllQuestsSearchStore = create<AllQuestsSearchStore>((set) => ({
  searchQuery: "",
  setSearchQuery: (searchQuery) => set({ searchQuery }),
}))
